$(document).ready(function () {
    // ============================================
    // MOCKUP TOOL - OPTIMIZED VERSION
    // ============================================
    const MockupTool = {
        // Current state
        state: {
            platform: 'facebook',
            format: '1-1',
            profileImage: null,
            profileName: '',
            description: '',
            mainImage: null,
            carouselImages: [],
            carouselHeadings: ['', ''], // Headings for each carousel slide
            likes: 0,
            comments: 0,
            ctaEnabled: false,
            ctaType: 'kup-teraz',
            ctaText: '',
            ctaColor: '#A950CC'
        },

        // CTA labels mapping
        ctaLabels: {
            'kup-teraz': 'Kup teraz',
            'obejrzyj-wiecej': 'Obejrzyj więcej',
            'polub-strone': 'Polub stronę',
            'skontkatuj-sie-z-nami': 'Skontaktuj się z nami',
            'skorzystaj-z-oferty': 'Skorzystaj z oferty',
            'uzyj-aplikacji': 'Użyj aplikacji',
            'wiecej-informacji': 'Więcej informacji',
            'wyslij-wiadomosc': 'Wyślij wiadomość',
            'zadzwon-teraz': 'Zadzwoń teraz',
            'zainstaluj-teraz': 'Zainstaluj teraz',
            'zarejestruj-sie': 'Zarejestruj się',
            'zarezerwuj-teraz': 'Zarezerwuj teraz'
        },

        // Cached DOM elements
        cache: {},

        // Debounce timers
        timers: {},

        // Initialize
        init: function () {
            this.cacheElements();
            this.clearFormInputs();
            this.bindEvents();
            this.showActivePreview();
        },

        // Clear form inputs on page load (browser may remember values)
        clearFormInputs: function () {
            $('#profile_name, #description, #cta_text').val('');
            $('#likes, #comments').val(0);
            $('#cta_color').val('#A950CC').next('span').text('#A950CC');
            $('[data-mockup-cta-dropdown]').val('kup-teraz').prop('disabled', true);
            $('[data-mockup-cta-toggle]').prop('checked', false);
            $('input[name="format"][value="1-1"]').prop('checked', true);
            $('#profile_image, #image, .carousel-upload__input').val('');
            $('[data-carousel-heading]').val('');

            // Hide conditional fields
            $('[data-mockup-cta-text], [data-mockup-cta-color], [data-mockup-carousel-headings]').addClass('is-hidden');
            $('[data-mockup-description], [data-mockup-likes-comments]').removeClass('is-hidden');

            // Reset tabs
            $('[data-mockup-tab]').removeClass('is-active');
            $('[data-mockup-tab="facebook"]').addClass('is-active');
            $('[data-mockup-fields]').removeClass('has-active-instagram').addClass('has-active-facebook');

            // Reset format class
            $('[data-mockup-tool]').removeClass(function (i, cls) {
                return (cls.match(/(^|\s)format-\S+/g) || []).join(' ');
            }).addClass('format-1-1');

            // Reset carousel/file upload visibility
            $('[data-mockup-carousel-upload]').addClass('is-hidden');
            $('[data-mockup-file]').removeClass('is-hidden');
        },

        // Cache frequently used elements
        cacheElements: function () {
            // Store default image paths from Twig assets (before any changes)
            this.defaultImages = {
                profileIcon: $('.mockup-tool__profile-image img').attr('src'),
                carouselImage: $('.carousel-upload__image').first().attr('src'),
                carouselIcon: $('.carousel-upload__icon').first().attr('src'),
                facebookMedia: $('[data-preview-facebook-post] .facebook__media img').attr('src'),
                facebookAvatar: $('[data-preview-facebook-post] .facebook__avatar img').attr('src'),
                instagramArrow: $('.instagram-carousel__button img').first().attr('src') || $('.instagram__button img').first().attr('src')
            };

            this.cache = {
                // Profile
                profileAvatars: $('.facebook__avatar img, .facebook-stories__avatar img, .facebook-reels__avatar img, .instagram__avatar img, .instagram-stories__avatar img, .instagram-reels__avatar img'),
                profileNames: {
                    facebook: $('.facebook__name, .facebook-stories__name, .facebook-reels__name'),
                    instagram: $('.instagram__name'),
                    instagramStories: $('.instagram-stories__name, .instagram-reels__name')
                },
                // Descriptions
                descriptions: {
                    facebook: $('.facebook__description, .facebook-reels__description'),
                    instagram: $('.instagram__description'),
                    instagramReels: $('.instagram-reels__description')
                },
                // Media
                mainMedia: {
                    facebook: $('.facebook__media img, .facebook-stories__media img, .facebook-reels__media img'),
                    instagram: $('.instagram__media img, .instagram-stories__media img, .instagram-reels__media img')
                },
                // Likes & comments
                fbLikes: $('.facebook__likes span'),
                fbComments: $('.facebook__comments'),
                igLikes: $('.instagram__details .instagram__detail:first-child span'),
                igComments: $('.instagram__details .instagram__detail:nth-child(2) span'),
                // CTA
                fbCta: $('[data-preview-facebook-post] .facebook__cta'),
                fbCtaTitle: $('.facebook__cta-title'),
                fbCtaButton: $('.facebook__cta-button'),
                fbCarouselCtaTitle: $('.facebook-carousel__cta-title'),
                fbCarouselCtaButton: $('.facebook-carousel__cta-button'),
                fbStoriesCtaLabel: $('.facebook-stories__cta-label'),
                fbReelsButton: $('.facebook-reels__button'),
                igButton: $('.instagram__button'),
                igCarouselButtons: $('.instagram-carousel__button'),
                igStoriesCtaLabel: $('.instagram-stories__cta-label'),
                igReelsButtonSpan: $('.instagram-reels__button span'),
                // Previews
                allPreviews: $('[data-mockup-preview] > div'),
                // Upload sections
                carouselUpload: $('[data-mockup-carousel-upload]'),
                fileUpload: $('[data-mockup-file]'),
                // Slider navs
                fbSliderNav: $('.result-actions__slider-nav--facebook'),
                igSliderNav: $('.result-actions__slider-nav--instagram')
            };
        },

        // Debounce helper
        debounce: function (key, fn, delay) {
            if (this.timers[key]) {
                clearTimeout(this.timers[key]);
            }
            this.timers[key] = setTimeout(fn, delay);
        },

        bindEvents: function () {
            const self = this;

            // Platform tabs - immediate
            $(document).on('click', '[data-mockup-tab]', function () {
                self.state.platform = $(this).data('mockup-tab');
                self.showActivePreview();
                self.updateCarouselUploadVisibility();
                self.updateSliderNavVisibility();
                self.updateCtaFieldsVisibility();
            });

            // Format change - immediate
            $(document).on('change', 'input[name="format"]', function () {
                self.state.format = $(this).val();

                // Auto-enable CTA for carousel formats
                if (self.state.format.includes('carousel') && !self.state.ctaEnabled) {
                    self.state.ctaEnabled = true;
                    $('[data-mockup-cta-toggle]').prop('checked', true);
                }

                self.showActivePreview();
                self.updateCarouselUploadVisibility();
                self.updateSliderNavVisibility();
                self.updateFieldsVisibility();
                self.updateCtaFieldsVisibility();
                self.updateCTA();
            });

            // Profile image upload - immediate
            $(document).on('change', '#profile_image', function (e) {
                self.handleImageUpload(e, 'profileImage', function () {
                    self.updateProfileImages();
                });
            });

            // Profile name - debounced
            $(document).on('input', '#profile_name', function () {
                self.state.profileName = $(this).val();
                self.debounce('profileName', function () {
                    self.updateProfileNames();
                }, 150);
            });

            // Description - debounced
            $(document).on('input', '#description', function () {
                self.state.description = $(this).val();
                self.debounce('description', function () {
                    self.updateDescriptions();
                }, 150);
            });

            // Main image upload - immediate
            $(document).on('change', '#image', function (e) {
                self.handleImageUpload(e, 'mainImage', function () {
                    self.updateMainImages();
                });
            });

            // Carousel images upload - immediate
            $(document).on('change', '.carousel-upload__input', function (e) {
                const index = $(this).closest('.carousel-upload__item').index();
                self.handleCarouselImageUpload(e, index);
            });

            // Likes - debounced
            $(document).on('input', '#likes', function () {
                self.state.likes = parseInt($(this).val()) || 0;
                self.debounce('likes', function () {
                    self.updateLikesComments();
                }, 150);
            });

            // Comments - debounced
            $(document).on('input', '#comments', function () {
                self.state.comments = parseInt($(this).val()) || 0;
                self.debounce('comments', function () {
                    self.updateLikesComments();
                }, 150);
            });

            // CTA toggle - immediate
            $(document).on('change', '[data-mockup-cta-toggle]', function () {
                const isChecked = $(this).is(':checked');
                const isCarousel = self.state.format.includes('carousel');

                // Prevent unchecking CTA for carousel
                if (isCarousel && !isChecked) {
                    $(this).prop('checked', true);
                    return;
                }

                self.state.ctaEnabled = isChecked;
                self.updateCTA();
            });

            // CTA dropdown - immediate
            $(document).on('change', '[data-mockup-cta-dropdown]', function () {
                self.state.ctaType = $(this).val();
                self.updateCTA();
            });

            // CTA text - debounced
            $(document).on('input', '#cta_text', function () {
                self.state.ctaText = $(this).val();
                self.debounce('ctaText', function () {
                    self.updateCTA();
                }, 150);
            });

            // Carousel headings - debounced
            $(document).on('input', '[data-carousel-heading]', function () {
                const index = parseInt($(this).data('carousel-heading'));
                self.state.carouselHeadings[index] = $(this).val();
                self.debounce('carouselHeading' + index, function () {
                    self.updateCarouselHeadings();
                }, 150);
            });

            // CTA color - debounced
            $(document).on('input', '#cta_color', function () {
                self.state.ctaColor = $(this).val();
                self.debounce('ctaColor', function () {
                    self.updateCTA();
                }, 100);
            });

            // Download button
            $(document).on('click', '#downloadButton', function (e) {
                e.preventDefault();
                self.downloadMockup();
            });

            // Clear button
            $(document).on('click', '#clearButton', function (e) {
                e.preventDefault();
                self.resetForm();
            });
        },

        handleImageUpload: function (e, stateKey, callback) {
            const self = this;
            const file = e.target.files[0];

            if (!file) return;

            const reader = new FileReader();
            reader.onload = function (event) {
                self.state[stateKey] = event.target.result;

                // Update profile image preview in form
                if (stateKey === 'profileImage') {
                    $(e.target).siblings('img').attr('src', event.target.result);
                }

                // Update main image filename display
                if (stateKey === 'mainImage') {
                    $('.file-upload__file-title').text(file.name);
                }

                if (callback) callback();
            };
            reader.readAsDataURL(file);
        },

        handleCarouselImageUpload: function (e, index) {
            const self = this;
            const file = e.target.files[0];

            if (!file) return;

            const reader = new FileReader();
            reader.onload = function (event) {
                self.state.carouselImages[index] = event.target.result;

                // Update carousel item preview
                const $item = $(e.target).closest('.carousel-upload__item');
                const $button = $item.find('.carousel-upload__button');
                let $img = $item.find('.carousel-upload__image');
                const $icon = $item.find('.carousel-upload__icon');

                if ($img.length === 0) {
                    // First time adding image - hide icon, add image
                    $icon.hide();
                    $button.append(
                        '<img class="carousel-upload__image" src="' + event.target.result + '" alt="">'
                    );
                } else {
                    $img.attr('src', event.target.result);
                }

                self.ensureCarouselSlideExists(index);

                // Always ensure heading input exists for this index
                self.addCarouselHeadingInput(index);

                self.addCarouselSlotIfNeeded();
                self.updateCarouselImages();
            };
            reader.readAsDataURL(file);
        },

        ensureCarouselSlideExists: function (index) {
            const $fbWrapper = $('[data-slider-facebook] .swiper-wrapper');
            const $igWrapper = $('[data-slider-instagram] .swiper-wrapper');

            const fbSlidesCount = $fbWrapper.find('.facebook-carousel__slide').length;
            const igSlidesCount = $igWrapper.find('.instagram-carousel__slide').length;

            // Get CTA values for new slides - use carousel heading for this index or empty
            const ctaTitle = this.state.carouselHeadings[index] || '';
            const ctaLabel = this.ctaLabels[this.state.ctaType] || 'Kup teraz';
            const ctaColor = this.state.ctaColor || '#A950CC';
            const defaultMedia = this.defaultImages.facebookMedia;
            const arrowIcon = this.defaultImages.instagramArrow;

            if (index >= fbSlidesCount) {
                $fbWrapper.append(`
                    <div class="swiper-slide facebook-carousel__slide">
                        <div class="facebook-carousel__card">
                            <figure class="facebook-carousel__media">
                                <img src="${defaultMedia}" alt="">
                            </figure>
                            <div class="facebook-carousel__cta">
                                <span class="facebook-carousel__cta-title">${ctaTitle}</span>
                                <div class="facebook-carousel__cta-button">${ctaLabel}</div>
                            </div>
                        </div>
                    </div>
                `);

                // Add heading input for this new slide
                this.addCarouselHeadingInput(index);
            }

            if (index >= igSlidesCount) {
                const igCtaHidden = this.state.ctaEnabled ? '' : 'is-hidden';
                $igWrapper.append(`
                    <div class="swiper-slide instagram-carousel__slide">
                        <div class="instagram-carousel__media-container">
                            <figure class="instagram-carousel__media">
                                <img src="${defaultMedia}" alt="">
                            </figure>
                            <span class="instagram-carousel__text">Sponsorowane</span>
                        </div>
                        <div class="instagram-carousel__button ${igCtaHidden}" style="background-color: ${ctaColor}">
                            <span>${ctaLabel}</span>
                            <img src="${arrowIcon}" alt="">
                        </div>
                    </div>
                `);
            }

            this.updateSwipers();
        },

        addCarouselSlotIfNeeded: function () {
            const $gallery = $('.carousel-upload');
            const $items = $gallery.find('.carousel-upload__item');
            const totalItems = $items.length;

            const iconSrc = this.defaultImages.carouselIcon;

            let emptySlots = 0;
            $items.each(function() {
                const $img = $(this).find('.carousel-upload__image');
                if ($img.length === 0 || $img.attr('src') === '') {
                    emptySlots++;
                }
            });

            if (emptySlots === 0 && totalItems < 10) {
                $gallery.append(`
                    <li class="carousel-upload__item">
                        <label class="carousel-upload__button">
                            <input class="carousel-upload__input" type="file" accept=".png,.jpg,.jpeg">
                            <img class="carousel-upload__icon" src="${iconSrc}" alt="">
                        </label>
                    </li>
                `);
            }
        },

        showActivePreview: function () {
            const platform = this.state.platform;
            const format = this.state.format;

            // Hide all
            this.cache.allPreviews.addClass('is-hidden');

            let selector = '';

            if (platform === 'facebook') {
                if (format.includes('carousel')) {
                    selector = '[data-preview-facebook-carousel]';
                } else if (format.includes('stories')) {
                    selector = '[data-preview-facebook-stories]';
                } else if (format.includes('reels')) {
                    selector = '[data-preview-facebook-reels]';
                } else {
                    selector = '[data-preview-facebook-post]';
                }
            } else {
                if (format.includes('carousel')) {
                    selector = '[data-preview-instagram-carousel]';
                } else if (format.includes('stories')) {
                    selector = '[data-preview-instagram-stories]';
                } else if (format.includes('reels')) {
                    selector = '[data-preview-instagram-reels]';
                } else {
                    selector = '[data-preview-instagram-post]';
                }
            }

            $(selector).removeClass('is-hidden');
        },

        updateCarouselUploadVisibility: function () {
            const isCarousel = this.state.format.includes('carousel');
            this.cache.carouselUpload.toggleClass('is-hidden', !isCarousel);
            this.cache.fileUpload.toggleClass('is-hidden', isCarousel);
        },

        updateSliderNavVisibility: function () {
            const platform = this.state.platform;
            const isCarousel = this.state.format.includes('carousel');

            this.cache.fbSliderNav.toggleClass('is-hidden', !(platform === 'facebook' && isCarousel));
            this.cache.igSliderNav.toggleClass('is-hidden', !(platform === 'instagram' && isCarousel));
        },

        updateFieldsVisibility: function () {
            const format = this.state.format;
            const isStories = format.includes('stories');
            const isReels = format.includes('reels');

            const $description = $('[data-mockup-description]');
            const $likesComments = $('[data-mockup-likes-comments]');

            if (isStories) {
                $description.addClass('is-hidden');
                $likesComments.addClass('is-hidden');
            } else if (isReels) {
                $description.removeClass('is-hidden');
                $likesComments.addClass('is-hidden');
            } else {
                $description.removeClass('is-hidden');
                $likesComments.removeClass('is-hidden');
            }
        },

        updateCtaFieldsVisibility: function () {
            const state = this.state;
            const isEnabled = state.ctaEnabled;
            const format = state.format;
            const isStories = format.includes('stories');
            const isReels = format.includes('reels');
            const isCarousel = format.includes('carousel');
            const isStoriesOrReels = isStories || isReels;

            const $ctaText = $('[data-mockup-cta-text]');
            const $ctaColor = $('[data-mockup-cta-color]');
            const $ctaDropdown = $('[data-mockup-cta-dropdown]');
            const $carouselHeadings = $('[data-mockup-carousel-headings]');

            // Dropdown - always enable/disable based on toggle
            $ctaDropdown.prop('disabled', !isEnabled);

            if (isEnabled && !isStories) {
                $ctaColor.removeClass('is-hidden');
                if (isReels) {
                    $ctaColor.css('display', 'block');
                } else {
                    $ctaColor.css('display', '');
                }
            } else {
                $ctaColor.addClass('is-hidden');
                $ctaColor.css('display', '');
            }

            if (isEnabled && !isStoriesOrReels && !isCarousel) {
                $ctaText.removeClass('is-hidden');
            } else {
                $ctaText.addClass('is-hidden');
            }

            if (isEnabled && isCarousel) {
                $carouselHeadings.removeClass('is-hidden');
            } else {
                $carouselHeadings.addClass('is-hidden');
            }
        },

        updateProfileImages: function () {
            const src = this.state.profileImage || '/build/images/icons/tool/facebook-avatar.png';
            this.cache.profileAvatars.attr('src', src);
        },

        updateProfileNames: function () {
            const name = this.state.profileName || '';
            const instaName = name ? name.toLowerCase().replace(/\s+/g, '_') : '';

            this.cache.profileNames.facebook.text(name);
            this.cache.profileNames.instagram.text(instaName);
            this.cache.profileNames.instagramStories.text(name);

            // Update description prefix
            $('.instagram__description b').text(instaName);
        },

        updateDescriptions: function () {
            const rawDescription = this.state.description || '';
            const description = rawDescription.replace(/\n/g, '<br>');

            this.cache.descriptions.facebook.html(description);
            this.cache.descriptions.instagramReels.html(description);

            // Instagram description with name prefix
            this.cache.descriptions.instagram.each(function () {
                const $b = $(this).find('b');
                const name = $b.text();
                $(this).html('<b>' + name + '</b> ' + description);
            });
        },

        updateMainImages: function () {
            const src = this.state.mainImage;
            if (src) {
                this.cache.mainMedia.facebook.attr('src', src);
                this.cache.mainMedia.instagram.attr('src', src);
            }
        },

        updateCarouselImages: function () {
            const images = this.state.carouselImages;

            $('.facebook-carousel__slide').each(function (index) {
                if (images[index]) {
                    $(this).find('.facebook-carousel__media img').attr('src', images[index]);
                }
            });

            $('.instagram-carousel__slide').each(function (index) {
                if (images[index]) {
                    $(this).find('.instagram-carousel__media img').attr('src', images[index]);
                }
            });
        },

        updateCarouselHeadings: function () {
            const headings = this.state.carouselHeadings;

            // Update Facebook carousel headings
            $('.facebook-carousel__slide').each(function (index) {
                const heading = headings[index] || '';
                $(this).find('.facebook-carousel__cta-title').text(heading);
            });
        },

        // Add new carousel heading input when adding new slide
        addCarouselHeadingInput: function (index) {
            const $list = $('[data-carousel-headings-list]');
            const existingInput = $list.find(`[data-carousel-heading="${index}"]`);

            if (existingInput.length === 0) {
                $list.append(`
                    <input class="mockup-tool__field" type="text" name="carousel_heading_${index}"
                           placeholder="Nagłówek slajdu ${index + 1}" data-carousel-heading="${index}">
                `);
                // Initialize state for new heading
                if (this.state.carouselHeadings[index] === undefined) {
                    this.state.carouselHeadings[index] = '';
                }
            }
        },

        updateLikesComments: function () {
            const likes = this.state.likes;
            const comments = this.state.comments;

            this.cache.fbLikes.text(likes);
            this.cache.fbComments.text(comments + ' komentarz' + this.getPolishSuffix(comments));

            this.cache.igLikes.text(likes);
            this.cache.igComments.text(comments);
        },

        getPolishSuffix: function (num) {
            if (num === 1) return '';
            if (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)) return 'e';
            return 'y';
        },

        updateCTA: function () {
            const state = this.state;
            const ctaLabel = this.ctaLabels[state.ctaType] || 'Kup teraz';
            const ctaText = state.ctaText || ''; // Empty if nothing entered
            const ctaColor = state.ctaColor || '#A950CC';

            // Update fields visibility first
            this.updateCtaFieldsVisibility();

            // Facebook post CTA
            if (state.ctaEnabled) {
                this.cache.fbCta.removeClass('is-hidden');
            } else {
                this.cache.fbCta.addClass('is-hidden');
            }

            this.cache.fbCtaTitle.text(ctaText);
            this.cache.fbCtaButton.text(ctaLabel); // No custom color for Facebook

            // Facebook carousel - use individual headings
            this.updateCarouselHeadings();
            this.cache.fbCarouselCtaButton.text(ctaLabel); // No custom color for Facebook

            // Facebook stories/reels
            this.cache.fbStoriesCtaLabel.text(ctaLabel);
            this.cache.fbReelsButton.text(ctaLabel);
            $('.facebook-reels__button').css('background-color', ctaColor);

            // === INSTAGRAM === (color is customizable)

            // Instagram post button - uses ctaLabel (button type), not ctaText (header)
            this.cache.igButton.toggleClass('is-hidden', !state.ctaEnabled);
            this.cache.igButton.find('span').text(ctaLabel);
            this.cache.igButton.css('background-color', ctaColor);

            // Instagram carousel buttons - use direct selector to include dynamically added slides
            $('.instagram-carousel__button').toggleClass('is-hidden', !state.ctaEnabled);
            $('.instagram-carousel__button').find('span').text(ctaLabel);
            $('.instagram-carousel__button').css('background-color', ctaColor);

            // Instagram stories/reels CTA labels
            this.cache.igStoriesCtaLabel.text(ctaLabel);
            this.cache.igReelsButtonSpan.text(ctaLabel);

            // Instagram reels button with custom color
            $('.instagram-reels__button').css('background-color', ctaColor);

            // Stories footers - hide when CTA disabled
            $('.instagram-stories__footer, .facebook-stories__footer').toggleClass('is-hidden', !state.ctaEnabled);

            // Reels buttons - hide when CTA disabled
            $('.facebook-reels__button, .instagram-reels__button').toggleClass('is-hidden', !state.ctaEnabled);
        },

        downloadMockup: function () {
            const self = this;
            const activePreview = document.querySelector('[data-mockup-preview] > div:not(.is-hidden)');

            if (!activePreview) {
                alert('Brak podglądu do pobrania');
                return;
            }

            if (typeof htmlToImage === 'undefined') {
                alert('Biblioteka do generowania obrazów nie została załadowana. Odśwież stronę.');
                return;
            }

            $('[data-mockup-loader]').addClass('is-visible');

            htmlToImage.toPng(activePreview, {
                quality: 1,
                pixelRatio: 1,
                backgroundColor: '#ffffff'
            }).then(function (dataUrl) {
                $('[data-mockup-loader]').removeClass('is-visible');

                const link = document.createElement('a');
                link.download = `mockup-${self.state.platform}-${self.state.format}-${Date.now()}.png`;
                link.href = dataUrl;
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();

                setTimeout(function() {
                    document.body.removeChild(link);
                }, 100);
            }).catch(function (error) {
                $('[data-mockup-loader]').removeClass('is-visible');
                console.error('Error:', error);
                alert('Wystąpił błąd podczas generowania obrazu. Spróbuj ponownie.');
            });
        },

        resetForm: function () {
            // Reset state
            this.state = {
                platform: 'facebook',
                format: '1-1',
                profileImage: null,
                profileName: '',
                description: '',
                mainImage: null,
                carouselImages: [],
                carouselHeadings: ['', ''],
                likes: 0,
                comments: 0,
                ctaEnabled: false,
                ctaType: 'kup-teraz',
                ctaText: '',
                ctaColor: '#A950CC'
            };

            // Reset form fields
            $('#profile_name, #description, #cta_text').val('');
            $('#likes, #comments').val(0);
            $('#cta_color').val('#A950CC').next('span').text('#A950CC');
            $('[data-mockup-cta-dropdown]').val('kup-teraz').prop('disabled', true);
            $('[data-mockup-cta-toggle]').prop('checked', false);
            $('input[name="format"][value="1-1"]').prop('checked', true);
            $('#profile_image, #image, .carousel-upload__input').val('');

            // Reset carousel heading inputs
            this.resetCarouselHeadingInputs();

            // Reset previews using cached default paths
            $('.mockup-tool__profile-image img').attr('src', this.defaultImages.profileIcon);
            $('.file-upload__file-title').text('post.png');

            // Reset tabs
            $('[data-mockup-tab]').removeClass('is-active');
            $('[data-mockup-tab="facebook"]').addClass('is-active');
            $('[data-mockup-fields]').removeClass('has-active-instagram').addClass('has-active-facebook');

            // Reset format class
            $('[data-mockup-tool]').removeClass(function (i, cls) {
                return (cls.match(/(^|\s)format-\S+/g) || []).join(' ');
            }).addClass('format-1-1');

            // Reset CTA fields visibility
            $('[data-mockup-cta-text], [data-mockup-cta-color], [data-mockup-carousel-headings]').addClass('is-hidden');

            // Reset fields visibility (show description, likes, comments)
            $('[data-mockup-description], [data-mockup-likes-comments]').removeClass('is-hidden');

            // Reset carousel gallery
            this.resetCarouselGallery();

            // Reset mockup preview images to defaults
            this.cache.profileAvatars.attr('src', this.defaultImages.facebookAvatar);
            this.cache.mainMedia.facebook.attr('src', this.defaultImages.facebookMedia);
            this.cache.mainMedia.instagram.attr('src', this.defaultImages.facebookMedia);

            // Update all preview elements
            this.showActivePreview();
            this.updateCarouselUploadVisibility();
            this.updateSliderNavVisibility();
            this.updateFieldsVisibility();
            this.updateProfileNames();
            this.updateDescriptions();
            this.updateLikesComments();
            this.updateCTA();
        },

        resetCarouselHeadingInputs: function () {
            const $list = $('[data-carousel-headings-list]');
            $list.empty();
            $list.append(`
                <input class="mockup-tool__field" type="text" name="carousel_heading_0"
                       placeholder="Nagłówek slajdu 1" data-carousel-heading="0">
                <input class="mockup-tool__field" type="text" name="carousel_heading_1"
                       placeholder="Nagłówek slajdu 2" data-carousel-heading="1">
            `);
        },

        resetCarouselGallery: function () {
            // Clear carousel images in state
            this.state.carouselImages = [];

            const $gallery = $('.carousel-upload');

            // Use cached default paths
            const iconSrc = this.defaultImages.carouselIcon;
            const imageSrc = this.defaultImages.carouselImage;

            // Remove all items
            $gallery.find('.carousel-upload__item').remove();

            // Add back initial state: 2 with default image + 1 with plus
            $gallery.append(`
                <li class="carousel-upload__item">
                    <label class="carousel-upload__button">
                        <input class="carousel-upload__input" type="file" accept=".png,.jpg,.jpeg">
                        <img class="carousel-upload__image" src="${imageSrc}" alt="">
                        <img class="carousel-upload__icon" src="${iconSrc}" alt="" style="display: none;">
                    </label>
                </li>
                <li class="carousel-upload__item">
                    <label class="carousel-upload__button">
                        <input class="carousel-upload__input" type="file" accept=".png,.jpg,.jpeg">
                        <img class="carousel-upload__image" src="${imageSrc}" alt="">
                        <img class="carousel-upload__icon" src="${iconSrc}" alt="" style="display: none;">
                    </label>
                </li>
                <li class="carousel-upload__item">
                    <label class="carousel-upload__button">
                        <input class="carousel-upload__input" type="file" accept=".png,.jpg,.jpeg">
                        <img class="carousel-upload__icon" src="${iconSrc}" alt="">
                    </label>
                </li>
            `);

            // Reset carousel sliders to 2 slides
            this.resetCarouselSliders();
        },

        resetCarouselSliders: function () {
            const defaultMedia = this.defaultImages.facebookMedia;

            // Facebook carousel - reset to 2 slides
            const $fbWrapper = $('[data-slider-facebook] .swiper-wrapper');
            $fbWrapper.find('.facebook-carousel__slide').slice(2).remove();
            $fbWrapper.find('.facebook-carousel__media img').attr('src', defaultMedia);

            // Instagram carousel - reset to 2 slides
            const $igWrapper = $('[data-slider-instagram] .swiper-wrapper');
            $igWrapper.find('.instagram-carousel__slide').slice(2).remove();
            $igWrapper.find('.instagram-carousel__media img').attr('src', defaultMedia);

            // Update swipers
            this.updateSwipers();
        },

        updateSwipers: function () {
            // Update swiper instances if they exist
            const fbSlider = document.querySelector('[data-slider-facebook]');
            const igSlider = document.querySelector('[data-slider-instagram]');

            if (fbSlider && fbSlider.swiper) {
                fbSlider.swiper.update();
            }
            if (igSlider && igSlider.swiper) {
                igSlider.swiper.update();
            }
        }
    };

    // Initialize
    MockupTool.init();

    (function initMockupTabs() {
        function updateMockupToolFormatClass(toolWrapper) {
            const selected = toolWrapper.querySelector('input[name="format"]:checked');
            if (!selected) return;

            toolWrapper.classList.forEach(cls => {
                if (cls.startsWith('format-')) toolWrapper.classList.remove(cls);
            });
            toolWrapper.classList.add(`format-${selected.value}`);
        }

        function updateFormatOptions(wrapper, activePlatform) {
            const option45 = wrapper.querySelector('input[value="carousel-4-5"]');
            const option11 = wrapper.querySelector('input[value="carousel-1-1"]');
            if (!option45 || !option11) return;

            if (activePlatform === 'facebook') {
                option45.closest('.radio-group__option').classList.add('is-hidden');
                option11.closest('.radio-group__option').classList.remove('is-hidden');
                if (option45.checked) {
                    option45.checked = false;
                    option11.checked = true;
                }
            } else {
                option45.closest('.radio-group__option').classList.remove('is-hidden');
                option11.closest('.radio-group__option').classList.add('is-hidden');
                if (option11.checked) {
                    option11.checked = false;
                    option45.checked = true;
                }
            }

            const toolWrapper = wrapper.closest('[data-mockup-tool]');
            if (toolWrapper) updateMockupToolFormatClass(toolWrapper);
        }

        $(document).on('click', '[data-mockup-tab]', function () {
            const platform = this.dataset.mockupTab;
            const wrapper = document.querySelector('[data-mockup-fields]');
            if (!wrapper) return;

            wrapper.classList.remove('has-active-facebook', 'has-active-instagram');
            wrapper.classList.add(`has-active-${platform}`);

            document.querySelectorAll('[data-mockup-tab]').forEach(t => t.classList.remove('is-active'));
            this.classList.add('is-active');

            updateFormatOptions(wrapper, platform);
        });

        $(document).on('change', 'input[name="format"]', function () {
            const toolWrapper = this.closest('[data-mockup-tool]');
            if (toolWrapper) updateMockupToolFormatClass(toolWrapper);
        });
    })();

    (function mockupSliders() {
        const fbSlider = document.querySelector('[data-slider-facebook]');
        if (fbSlider) {
            new Swiper(fbSlider, {
                slidesPerView: 1.245,
                centeredSlides: true,
                centeredSlidesBounds: true,
                spaceBetween: 12,
                speed: 1000,
                navigation: {
                    prevEl: '.slider-arrow--prev-facebook',
                    nextEl: '.slider-arrow--next-facebook',
                },
                observer: true,
                observeParents: true,
            });
        }

        const igSlider = document.querySelector('[data-slider-instagram]');
        if (igSlider) {
            new Swiper(igSlider, {
                slidesPerView: 1,
                centeredSlides: true,
                spaceBetween: 12,
                speed: 1000,
                navigation: {
                    prevEl: '.slider-arrow--prev-instagram',
                    nextEl: '.slider-arrow--next-instagram',
                },
                pagination: {
                    el: '.instagram-carousel__nav',
                    clickable: true,
                },
                observer: true,
                observeParents: true,
            });
        }
    })();

    const colorInput = document.getElementById('cta_color');
    if (colorInput) {
        const span = colorInput.nextElementSibling;
        span.textContent = colorInput.value;
        colorInput.addEventListener('input', (e) => {
            span.textContent = e.target.value.toUpperCase();
        });
    }
});